import { render, staticRenderFns } from "./OfferItemBaseGroup.vue?vue&type=template&id=84e4d260"
import script from "./OfferItemBaseGroup.vue?vue&type=script&lang=js"
export * from "./OfferItemBaseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84e4d260')) {
      api.createRecord('84e4d260', component.options)
    } else {
      api.reload('84e4d260', component.options)
    }
    module.hot.accept("./OfferItemBaseGroup.vue?vue&type=template&id=84e4d260", function () {
      api.rerender('84e4d260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OfferItemBaseGroup.vue"
export default component.exports